<template>
  <div :class="classObj" class="app-wrapper">
    <div class="fixed-header">
      <navbar :pageTitle="pageTitle" :hideNavAction="hideNavAction" />
    </div>
    <app-main />
  </div>
</template>

<script>
import { AppMain, Navbar } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { mapState } from "vuex";

export default {
  name: "Layout",
  components: {
    AppMain,
    Navbar
  },
  data() {
    return {
      pageTitle: "",
      hideNavAction: false
    };
  },
  mixins: [ResizeMixin],
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.pageTitle = to.meta.title;
        this.hideNavAction = to.meta.hideNavAction;
      }
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device
    }),
    classObj() {
      return {
        // hideSidebar: !this.sidebar.opened,
        // openSidebar: this.sidebar.opened,
        // withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile"
      };
    }
  },
  methods: {
    handleClickOutside() {
      // this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  left: 0;
  // width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
</style>
